import createSagaMiddleware from "@redux-saga/core";
import { createStore, applyMiddleware, compose } from "redux";
import { persistStore } from "redux-persist";
import rootSaga from "../rootSaga";
import { persistedReducer } from "../rootReducer";
import * as Sentry from "@sentry/react";
import { reduxBreadcrumbMiddleware } from "./reduxBreadcrumbMiddleware";

//persist configuration
const sagaMiddleware = createSagaMiddleware();

const sentryReduxMiddleware = (store) => (next) => (action) => {
  try {
    return next(action);
  } catch (error) {
    Sentry.captureException(error, {
      tags: { source: "redux" },
      extra: { action }
    });
    throw error;
  }
};

//compose with redux devTool
const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

//store configuration
const store = createStore(
  persistedReducer,
  composeEnhancer(
    applyMiddleware(
      reduxBreadcrumbMiddleware,
      sentryReduxMiddleware,
      sagaMiddleware
    )
  )
);
sagaMiddleware.run(rootSaga);
export const persistor = persistStore(store);
//saga run
export default store;
